module.exports = __webpack_public_path__ + "static/media/0.VPM_Frontpage.c6349c5b.jpg";